import { EditorKeyboardEvent } from 'sierra-domain/v3-author'
import { Editor, Transforms } from 'slate'

export const shortcuts = (event: EditorKeyboardEvent, editor: Editor): void => {
  if (event.key === 'Enter' && event.shiftKey) {
    event.preventDefault()
    Transforms.insertNodes(editor, { text: '\n' })
  }
}
